import { PageHeader } from "@ant-design/pro-components";
import { CopyAllOutlined, MarkChatReadOutlined, Message } from "@mui/icons-material";
import { Alert, Button, Card, Checkbox, Form, Input, message, Select, Textarea } from "antd";
import { memo, useEffect, useState } from "react";
import api from "../../../api/api";
import styles from "./PredefinedSms.module.css";
import DataTable from "../../../Components/DataTable/DataTable";
import { toJalaali } from "jalaali-js";
import PredefinedSmsActions from "../../../Components/PredefinedSms/PredefinedSmsActions";

const PredefinedSms = () => {
  const [predefinedList, setPredefinedList] = useState([]);

  const columns = [
    {
      title: "شناسه",
      dataIndex: "id",
      searchable: true,
    },
    {
      title: "عنوان",
      dataIndex: "key",
      searchable: true,
    },
    {
      title: "متن",
      dataIndex: "text",
    },
    {
      title: "وضعیت",
      dataIndex: "active",
      render: (value, record) => {
        return <Checkbox key={record.id} checked={value} onChange={() => changeStatus(record)} />;
      },
    },
    {
      title: "زمان ایجاد",
      dataIndex: "createdAt",
      render: (text, record) => {
        if (text && text != "-") {
          const date = new Date(text);
          const jalali = toJalaali(date.getFullYear(), date.getMonth() + 1, date.getDate());
          return (
            <span dir="ltr">
              {jalali.jy}-{jalali.jm}-{jalali.jd} {date.toLocaleTimeString("eo", { hour12: false })}
            </span>
          );
        }
      },
    },
    {
      title: "عملیات",
      render: (_, record) => <PredefinedSmsActions record={record} onClick={editPredefinedSms} />,
    },
  ];

  useEffect(() => {
    loadPredefinedList();
  }, []);

  const loadPredefinedList = () => {
    api.get("/smspredefined/list").then((res) => {
      const data = res.data;
      setPredefinedList(data);
    });
  };

  const editPredefinedSms = (record) => {
    window.location.href = "/predefined-sms/edit/" + record.id;
  };

  const changeStatus = (record) => {
    const newStatus = !record.active;
    predefinedList.forEach((item) => {
      if (item.id === record.id) {
        item.active = newStatus;
      }
    });
    setPredefinedList([...predefinedList]);

    api.post("/smspredefined/" + record.id + "/changeStatus", { status: newStatus ? "active" : "inactive" }).then((res) => {
      if (res.data.success) {
        message.success("وضعیت با موفقیت تغییر کرد.");
      } else {
        message.error("خطا در تغییر وضعیت.");
      }
    });
  };

  return (
    <DataTable
      tableKey="predefined-sms"
      id="PredefinedList"
      dataSource={predefinedList}
      setDataSource={setPredefinedList}
      columns={columns}
      // permissionsPrefix="flags"
      reload={loadPredefinedList}
      recordCreatorDisabled
      header={{
        title: "لیست پیامک با قالب",
        avatar: { icon: <MarkChatReadOutlined />, size: "large" },
        extra: (<Button
          type="primary"
          onClick={() => {
            window.location.href = "/predefined-sms/create";
          }}
        >
          ایجاد قالب
        </Button>),
      }}
    />
  );
};

export default memo(PredefinedSms);
